export default "/_next/static/images/632df2036741de6ca130be5badb19ef1.jpg";